var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.398 21.6.255-1.275.945-4.725L15.951 3.248l.847-.848.848.848 3.101 3.1.851.852-.847.848L8.398 20.4l-4.725.945zm5.408-2.306 9.521-9.518-3.101-3.101-9.521 9.517-.777 3.878zM18.175 8.929 19.9 7.2l-3.102-3.101-1.728 1.725 3.1 3.101z"
  })));
};
export default SvgPen;